/**
 * All posible types of Http Verb request.
 * Use this Enum for setup the connectionService.
 */
export enum CommandRequestType {
  GET,
  POST,
  DELETE,
  PUT,
  PATCH
}
